module.exports = __webpack_public_path__ + "static/media/CircularPro-Book.ac0c437a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-Book.eot
// module id = 103
// module chunks = 0